<template>
  <div id="gallery-list" class="gallery-list">
    <div class="gallery-list-width">
      <div class="gallery-list-pic">
        <v-img :src="require('../assets/img/gallerytop_sp@2x.png')" />
      </div>
      <div class="gallery-list-2020">
        <v-img :src="require('../assets/img/group9@2x.png')" />
      </div>
      <div class="gallery-list-area">
        <div class="gallery-list-area-photo" v-for="data in filterByCategory2020" :key="data.id">
          <v-img :src="data.path" @click="clickGalleryList(data.path)" />
        </div>
      </div>
      <div class="gallery-list-2021">
        <v-img :src="require('../assets/img/group10@2x.png')" />
      </div>
      <div class="gallery-list-area">
        <div class="gallery-list-area-photo" v-for="data in filterByCategory2021" :key="data.id">
          <v-img :src="data.path" @click="clickGalleryList(data.path)" />
        </div>
      </div>
      <div class="gallery-list-2022">
        <v-img :src="require('../assets/img/group11@2x.png')" />
      </div>
      <div class="gallery-list-area">
        <div class="gallery-list-area-photo" v-for="data in filterByCategory2022" :key="data.id">
          <v-img :src="data.path" @click="clickGalleryList(data.path)" />
        </div>
      </div>
    </div>

    <div class="gallery-fullscreen" v-if="selectedPath">
      <div class="gallery-fullscreen-bg" @click="clickGalleryScreen()" />

      <v-img class="gallery-fullscreen-image" :src="selectedPath">
        <div class="gallery-fullscreen-taparea">
          <div class="gallery-fullscreen-taparea-left" @click="clickLeft"></div>
          <div class="gallery-fullscreen-taparea-right" @click="clickRight"></div>
        </div>
        <!-- <v-btn elevation="2" icon class="gallery-fullscreen-button" @click="clickGalleryButton()">
          <v-icon>mdi-close</v-icon>
        </v-btn> -->
      </v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GalleryList',
  data() {
    return {
      galleryFlg: false,
      galleryList: [
        /* 2020年 */
        {
          id: 202010,
          path: require('../assets/img/202010.png'),
          category: 2020
        },
        {
          id: 202011,
          path: require('../assets/img/202011.png'),
          category: 2020
        },
        {
          id: 202012,
          path: require('../assets/img/202012.png'),
          category: 2020
        },
        /**2021年 */
        {
          id: 202101,
          path: require('../assets/img/202101.png'),
          category: 2021
        },
        {
          id: 202102,
          path: require('../assets/img/202102.png'),
          category: 2021
        },
        {
          id: 202103,
          path: require('../assets/img/202103.png'),
          category: 2021
        },
        {
          id: 202104,
          path: require('../assets/img/202104.png'),
          category: 2021
        },
        {
          id: 202105,
          path: require('../assets/img/202105.png'),
          category: 2021
        },
        {
          id: 202106,
          path: require('../assets/img/202106.png'),
          category: 2021
        },
        {
          id: 1202107,
          path: require('../assets/img/202107.png'),
          category: 2021
        },
        {
          id: 202108,
          path: require('../assets/img/202108.png'),
          category: 2021
        },
        {
          id: 202109,
          path: require('../assets/img/202109.png'),
          category: 2021
        },
        {
          id: 202110,
          path: require('../assets/img/202110.png'),
          category: 2021
        },
        {
          id: 202111,
          path: require('../assets/img/202111.png'),
          category: 2021
        },
        {
          id: 202112,
          path: require('../assets/img/202112.png'),
          category: 2021
        },
        /* 2022年 */
        {
          id: 202201,
          path: require('../assets/img/202201.png'),
          category: 2022
        },
        {
          id: 202202,
          path: require('../assets/img/202202.png'),
          category: 2022
        },
        {
          id: 202203,
          path: require('../assets/img/202203.png'),
          category: 2022
        },
        {
          id: 202204,
          path: require('../assets/img/202204.png'),
          category: 2022
        },
        {
          id: 202205,
          path: require('../assets/img/202205.png'),
          category: 2022
        },
        {
          id: 202206,
          path: require('../assets/img/202206.png'),
          category: 2022
        },
        {
          id: 202207,
          path: require('../assets/img/202207.png'),
          category: 2022
        },
        {
          id: 202208,
          path: require('../assets/img/202208.png'),
          category: 2022
        },
        {
          id: 202209,
          path: require('../assets/img/202209.png'),
          category: 2022
        },
        {
          id: 202210,
          path: require('../assets/img/202210.png'),
          category: 2022
        }
        // {
        //   id: 202211,
        //   path: require('../assets/img/202211.png'),
        //   category: 2022
        // },
        // {
        //   id: 202212,
        //   path: require('../assets/img/202212.png'),
        //   category: 2022
        // }
      ],
      selectedPath: ''
    };
  },
  computed: {
    filterByCategory2020() {
      return this.galleryList.filter(gallery => gallery.category == 2020);
    },
    filterByCategory2021() {
      return this.galleryList.filter(gallery => gallery.category == 2021);
    },
    filterByCategory2022() {
      return this.galleryList.filter(gallery => gallery.category == 2022);
    }
  },

  methods: {
    clickGalleryList(path) {
      this.selectedPath = path;
    },
    clickGalleryScreen() {
      this.selectedPath = '';
    },
    clickGalleryButton() {
      this.selectedPath = '';
    },
    clickLeft() {
      const index = this.galleryList.findIndex(d => d.path == this.selectedPath);
      if (index < 0) {
        return;
      }
      if (index == 0) {
        this.selectedPath = this.galleryList[this.galleryList.length - 1].path;
        return;
      }
      this.selectedPath = this.galleryList[index - 1].path;
    },
    clickRight() {
      const index = this.galleryList.findIndex(d => d.path == this.selectedPath);
      if (index < 0) {
        return;
      }
      if (index == this.galleryList.length - 1) {
        this.selectedPath = this.galleryList[0].path;
        return;
      }
      this.selectedPath = this.galleryList[index + 1].path;
    }
  }
};
</script>

<style lang="scss" scoped>
.gallery-list {
  & {
    background-color: #fce8a8;
    overflow: hidden;
  }
  &-width {
    margin: 0 auto;
    max-width: 1000px;
  }
  &-pic {
    width: 80%;
    margin-top: 18%;
    margin-left: 10%;
  }
  &-2020,
  &-2021,
  &-2022 {
    width: 40%;
    margin-left: 30%;
  }

  &-area {
    & {
      height: auto;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 12px 0;
    }
    &-photo {
      padding: 10px;
      width: 50%;
    }
  }
}
.gallery-fullscreen {
  &-bg {
    z-index: 10001;
    position: fixed;
    background-color: #000000;
    opacity: 0.5;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
  &-image {
    z-index: 10002;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 100vh;
    transform: translate(-50%, -50%);
  }
  &-button {
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 10003;
  }

  &-taparea {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;

    &-left {
      width: 50%;
      height: 100%;
    }
    &-right {
      width: 50%;
      height: 100%;
    }
  }
}
</style>
